import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const badge = (s, t) => {
  const map = { open: "bg-yellow-100 text-yellow-700", resolved: "bg-emeraude/15 text-emeraude-dark", rejected: "bg-red-100 text-red-600" };
  return <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${map[s] || "bg-sand text-muted2"}`}>{t(`litiges.${s || "open"}`)}</span>;
};

export function DisputesPanel({ onUpgrade }) {
  const { t } = useTranslation();
  const [locked, setLocked] = useState(false);
  const [disputes, setDisputes] = useState([]);

  useEffect(() => {
    api.get("/loueur/disputes").then((r) => setDisputes(r.data.disputes)).catch((e) => {
      if (e.response?.status === 403) setLocked(true);
    });
  }, []);

  if (locked) return (
    <div data-testid="disputes-locked" className="text-center py-12 bg-white rounded-2xl border border-border">
      <Lock className="w-8 h-8 text-canard mx-auto mb-3" />
      <p className="text-muted2 font-body mb-4">{t("litiges.locked")}</p>
      <Button data-testid="disputes-upgrade" onClick={onUpgrade} className="rounded-full bg-canard hover:bg-canard-dark font-bold">{t("litiges.upgrade")}</Button>
    </div>
  );
  if (!disputes.length) return <div className="text-center py-12 bg-white rounded-2xl border border-border text-muted2 font-body">{t("litiges.empty")}</div>;
  return (
    <div className="bg-white rounded-2xl shadow-card border border-border overflow-x-auto" data-testid="disputes-table">
      <table className="w-full text-sm">
        <thead className="bg-sand"><tr className="text-left text-muted2 font-bold text-xs uppercase"><th className="p-3">{t("litiges.ref")}</th><th className="p-3">{t("litiges.vehicle")}</th><th className="p-3">{t("litiges.client")}</th><th className="p-3">{t("litiges.amount")}</th><th className="p-3">{t("litiges.reason")}</th><th className="p-3">{t("litiges.status")}</th></tr></thead>
        <tbody>
          {disputes.map((d) => (
            <tr key={d.id} data-testid={`dispute-row-${d.id}`} className="border-t border-border font-body">
              <td className="p-3 font-bold text-canard-dark">{d.ref}</td>
              <td className="p-3">{d.vehicle_name}</td>
              <td className="p-3">{d.driver_name}</td>
              <td className="p-3 font-bold">{d.amount} €</td>
              <td className="p-3 max-w-[220px] truncate">{d.dispute?.reason}</td>
              <td className="p-3">{badge(d.dispute?.status, t)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
